module.exports = {
  'en': {
    'HRMS76X1': {
      '10': 'For Year',
      '20': 'Department',
      '30': 'Position',
      '40': 'Emp. Code',
      '50': 'Emp. Code',
      '60': 'Employee Name',
      '70': 'Position',
      '80': 'Level',
      '90': 'Course Name',
      '100': 'Category',
      '110': 'Tr.Program',
      '120': 'Status',
      '130': 'Select All'
    }
  },
  'th': {
    'HRMS76X1': {
      '10': 'สำหรับปี',
      '20': 'หน่วยงาน',
      '30': 'ตำแหน่ง',
      '40': 'รหัสพนักงาน',
      '50': 'รหัสพนักงาน',
      '60': 'ชื่อ-นามสกุล',
      '70': 'ตำแหน่ง',
      '80': 'ระดับ',
      '90': 'ชื่อหลักสูตร',
      '100': 'ประเภท',
      '110': 'รหัสโครงการ',
      '120': 'สถานะ',
      '130': 'ทั้งหมด'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hrms76x.js